var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isEdit
      ? _c(
          "div",
          { staticClass: "mb-10 search-box" },
          [
            _c(
              "el-input",
              {
                ref: "kwInput",
                attrs: { placeholder: "请输入地址搜索", clearable: "" },
                on: { input: _vm.onKeywordInput, clear: _vm.onKeywordClear },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchKeyword($event)
                  },
                },
                model: {
                  value: _vm.keyword,
                  callback: function ($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: { click: _vm.searchKeyword },
                    slot: "append",
                  },
                  [_vm._v("搜索")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { ref: "map_box", staticClass: "bm-view", style: { height: _vm.height } },
      [
        _c("div", { ref: "tdtMap", staticClass: "tdt-map" }),
        _vm._v(" "),
        _vm.isEdit
          ? _c("img", {
              staticClass: "map-icon",
              attrs: {
                src: require("@/assets/marker_red_sprite.png"),
                alt: "",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isEdit && _vm.searchResults.length
          ? _c(
              "div",
              { staticClass: "search-list" },
              _vm._l(_vm.searchResults, function (item, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticClass: "search-item",
                    on: {
                      click: function ($event) {
                        return _vm.selectResult(item)
                      },
                    },
                  },
                  [
                    _vm._v("\n        " + _vm._s(item.title) + "\n        "),
                    _c("div", { staticClass: "search-addr" }, [
                      _vm._v(_vm._s(item.address)),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }